import { useEffect } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const REFRESH_KEY = "__skeleton_auto_refresh__";

export const PortfolioSkeleton = () => {
  useEffect(() => {
    const alreadyRefreshed = sessionStorage.getItem(REFRESH_KEY);
    if (alreadyRefreshed) return;

    const timer = setTimeout(() => {
      sessionStorage.setItem(REFRESH_KEY, "true");
      window.location.reload();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Page header section */}
      <section className="py-12 md:py-16 bg-card">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center space-y-4">
            <Skeleton className="h-16 w-16 rounded-full mx-auto" />
            <Skeleton className="h-12 w-48 mx-auto" />
            <Skeleton className="h-6 w-96 max-w-full mx-auto" />
          </div>
        </div>
      </section>

      {/* Filter bar skeleton */}
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-wrap gap-2 justify-center mb-8">
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} className="h-9 w-24 rounded-full" />
          ))}
        </div>

        {/* Portfolio grid skeleton */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="space-y-3">
              <Skeleton className="aspect-video w-full rounded-lg" />
              <div className="space-y-2 p-2">
                <div className="flex gap-2">
                  <Skeleton className="h-5 w-16 rounded-full" />
                  <Skeleton className="h-5 w-20 rounded-full" />
                </div>
                <Skeleton className="h-6 w-3/4" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-2/3" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
